import { Injectable } from '@angular/core';
import { BackendService } from '../../services/new-http/backend.service';

@Injectable({
    providedIn: 'root',
})
export class FixedIncomeReportService extends BackendService {
    public getFile(url: string) {
        return this.fixedIncomeApi.getFile(url);
    }
}